module.exports = __webpack_public_path__ + "img/vue-crud-lg.5e3bc595.png";